var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindstorm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7,31.4c-7.6,0-13.8,6.2-13.8,13.8l0,0l0,0l0,0c0,4.4,3.8,8.7,8.7,8.7c4.7,0,8.7-3.8,8.7-8.7c0-1.6-0.4-3.1-1.3-4.7 c-0.7-1.1-2.2-1.6-3.6-0.9c-1.1,0.7-1.6,2.2-0.9,3.6c1.6,2.4-0.2,5.6-3.1,5.6c-2,0-3.6-1.6-3.6-3.6c0-4.9,4-8.7,8.7-8.7 c4.9,0,8.7,5.8,8.7,10.4c0,4.9-4,8.7-8.7,8.7H6.4C5.1,55.6,4,56.7,4,58s1.1,2.4,2.4,2.4h25.3h0.2c7.6-0.2,13.5-6.2,13.5-13.8 C45.5,39.4,39.5,31.4,31.7,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2,63.6C24.2,63.6,23.9,63.6,24.2,63.6H3.7c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h20.2c3.8,0,6.9,3.1,6.9,6.9 c0,3.8-3.1,6.9-6.9,6.9s-6.9-3.1-6.9-6.9c0-1.1-0.9-2-2-2c-1.3,0.2-2.2,1.1-2.2,2.2c0,6,4.9,10.9,10.9,10.9s10.9-4.9,10.9-10.9 C34.8,68.7,29.9,63.8,24.2,63.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.8,80.7 98.8,53.8 73.5,33.6 48.1,53.6 48.1,80.7 65.2,80.7 65.2,62.2 81.7,62.2 81.7,80.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7,52.7L88.1,21.8c-0.9-1.3-2.7-2-4.2-1.3l-34.6,12c-2,0.7-3.1,2.9-2.2,4.9c0.7,2,2.9,2.9,4.9,2.2l31.5-11.1l18,28.2 c1.1,1.8,3.6,2.2,5.3,1.1C108.3,56.9,108.8,54.5,107.7,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.1,82.9H46.6c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h53.5c1.1,0,2-0.9,2-2C102.1,83.8,101.2,82.9,100.1,82.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindstorm);
export default __webpack_public_path__ + "static/media/windstorm.433731f416d8743d56a2d7b19d5aec14.svg";
export { ForwardRef as ReactComponent };